import { Component, Prop, Vue } from 'vue-property-decorator';
import { languageItem } from '@/language/helpers';
@Component({
    name: 'TixStepper',
})
export default class default_1 extends Vue {
    l = languageItem('ticketTypeSteppers');
    @Prop({ required: true })
    value;
    @Prop({ default: 1 })
    nextIncrement;
    @Prop({ default: 1 })
    nextDecrement;
    @Prop({ default: 'Increase' })
    increaseButtonLabel;
    @Prop({ default: 'Decrease' })
    decreaseButtonLabel;
    @Prop({ required: true })
    countLabel;
    increment() {
        this.$emit('input', this.value + this.nextIncrement);
    }
    decrease() {
        this.$emit('input', this.value - this.nextDecrement);
    }
}
